import SUBROUTES from '../subroutes'
import {useMemo} from 'react'
import useOcapiSite from '../../../commerce-api/hooks/useOcapiSite'

const useMyStokkeSubroutes = () => {
    const {myStokkeConfig} = useOcapiSite()

    return useMemo(
        () =>
            SUBROUTES.map((route) => ({
                ...route,
                config: myStokkeConfig[route.configId]
            })),
        [myStokkeConfig]
    )
}

export default useMyStokkeSubroutes
